/** A printed card's number: MMDD + running number + batch + year + design (0376). */
const CARD_NUMBER = /^[0-9]{12}20[0-9]{2}[A-Z]$/;

/**
 * Pasted text → unique card numbers, and the lines that are not one. Lines,
 * commas, tabs and spaces all separate (a column pasted from a sheet works).
 */
export function parseCardNumbers(text: string): { codes: string[]; invalid: string[] } {
  const tokens = text
    .split(/[\s,;]+/)
    .map((t) => t.trim().toUpperCase())
    .filter(Boolean);
  const codes: string[] = [];
  const invalid: string[] = [];
  for (const token of tokens) {
    if (!CARD_NUMBER.test(token)) invalid.push(token);
    else if (!codes.includes(token)) codes.push(token);
  }
  return { codes, invalid };
}
